/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'inbox': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M180.7 99.5l-16.2-16.2-26.1 26.2V11.6h-22.8v97.9L89.5 83.3 73.3 99.5l53.7 53.6zM167.9 159.8l-22.8 22.8h-36.2l-22.8-22.8H13V251h228v-91.2h-73.1zm50.3 68.4H35.8v-45.6h40.9l22.8 22.8h55l22.8-22.8h40.9v45.6z"/>'
  }
})
